import React, { Component } from 'react';
import axios from 'axios';
import config from '../../../../../config';
import SaveButton from '../../../../commons/Buttons/SaveButton';

export default class General extends Component {
    state = {
        isSaving: false,
        organization_name: '',
        admin_email: '',
        big_logo: '',
        small_logo: ''
    };

    handleClick = () => {
        this.setState({
            isSaving: true
        });

        let url = `${config.apiUrl}settings`;

        let data = new FormData();
        data.append('type', 'general');
        data.append('organization_name', this.state.organization_name);
        data.append('admin_email', this.state.admin_email);

        let bigLogo = document.getElementById('big-logo').files;
        let smallLogo = document.getElementById('small-logo').files;

        if (bigLogo && bigLogo[0]) {
            data.append('big_logo', bigLogo[0]);
        }

        if (smallLogo  && smallLogo[0]) {
            data.append('small_logo', smallLogo[0]);
        }

        axios.post(url, data).then((res) => {
            console.log(res);

            this.setState({
                isSaving: false
            });

            this.props.getSettingsForTenant();

            this.props.showNotification('success', 'Settings Updated!');
        }).catch((error) => {
            console.log(error);

            this.setState({
                isSaving: false
            });

            this.props.showNotification('error', 'Failed to update settings');
        });
    };

    readURL = (input, $el) => {
        if (input.files && input.files[0]) {
            let reader = new FileReader();

            reader.onload = function (e) {
                $el.src = e.target.result;
            };

            reader.readAsDataURL(input.files[0]);
        }

    };

    handleFileChange = (e) => {
        let previewId = `${e.target.id}-preview`;
        let previewElement = document.getElementById(previewId);

        this.readURL(e.target, previewElement);
    };

    handleInputChange = (e) => {
        let data = {};
        data[e.target.id] = e.target.value;

        this.setState(data);
    };

    handleError = (e) => {
        let src = '/images/logo.png';
        if (e.target.id === 'big-logo-preview') {
            src = '/images/medix_logo.png';
        }

        e.target.src = src;
    };

    mapSettingsParameters = (settings) => {
        for (let setting of settings) {
            if (setting.type !== 'general') {
                continue;
            }

            let data = {};
            data[setting.param] = setting.value;

            this.setState(data);
        }
    };

    componentDidMount() {
        this.mapSettingsParameters(this.props.settings);
    }

    componentWillReceiveProps(nextProps) {
        this.mapSettingsParameters(nextProps.settings);
    }

    render() {
        return (
            <div id="general_settings_container" ref="container">
                <div className="row">
                    <form action="" encType="multipart/form-data">
                        <div className="form-group form-md-line-input col-md-12 col-lg-12 col-sm-12">
                            <label className="col-md-2 control-label" htmlFor="organization_name">
                                Organization Name
                                <br/>
                                <small>Name of your clinic</small>
                            </label>

                            <div className="col-md-10">
                                <input type="text" className="form-control"
                                       value={this.state.organization_name}
                                       onChange={this.handleInputChange}
                                       id="organization_name" placeholder="Name of your clinic" />
                                <div className="form-control-focus"> </div>
                            </div>
                        </div>

                        <div className="form-group form-md-line-input col-md-12 col-lg-12 col-sm-12">
                            <label className="col-md-2 control-label" htmlFor="admin-email">
                                Admin Email
                                <br/>
                                <small>Email of the admin where Medix will send news and updates regarding Medix App</small>
                            </label>
                            <div className="col-md-10">
                                <input type="text" className="form-control"
                                       value={this.state.admin_email}
                                       onChange={this.handleInputChange}
                                       id="admin_email"
                                       placeholder="Enter admin email" />
                                <div className="form-control-focus"> </div>
                            </div>
                        </div>

                        <div className="form-group form-md-line-input col-md-12 col-lg-12 col-sm-12">
                            <div className="col-md-10 col-md-offset-2">
                                <div className="big-logo-preview text-center">

                                    <img src={config.staticFiles + this.state.big_logo}
                                         onError={this.handleError}
                                         id="big-logo-preview"
                                         alt="big logo preview"
                                         className="img-responsive"
                                         />
                                </div>
                            </div>
                            
                            <label className="col-md-2 control-label" htmlFor="big-logo">
                                Big Logo
                                <br/>
                                <small>This is the logo that you see on the login page</small>
                            </label>

                            <div className="col-md-10">
                                <input type="file" className="form-control" id="big-logo"
                                       accept="image/*"
                                       onChange={this.handleFileChange}
                                       placeholder="Select big logo" />
                                <div className="form-control-focus"> </div>
                            </div>
                        </div>

                        <div className="form-group form-md-line-input col-md-12 col-lg-12 col-sm-12">
                            <div className="col-md-10 col-md-offset-2">
                                <div className="small-logo-preview text-center"
                                     style={{ width: '230px', height: '80px', margin: '30px auto' }}>

                                    <img src={config.staticFiles + this.state.small_logo}
                                         onError={this.handleError}
                                         id="small-logo-preview"
                                         alt="big logo preview"
                                         style={{height: '100%'}} />
                                </div>
                            </div>

                            <label className="col-md-2 control-label" htmlFor="small-logo">
                                Small Logo
                                <br/>
                                <small>This is the logo that you see on the header navigation bar</small>
                            </label>
                            <div className="col-md-10">
                                <input type="file" className="form-control" id="small-logo"
                                       accept="image/*"
                                       onChange={this.handleFileChange}
                                       placeholder="Select small logo" />

                                <div className="form-control-focus"> </div>
                            </div>
                        </div>

                        <hr/>

                        <div className="form-actions col-md-12 col-lg-12 col-sm-12"
                             style={{ borderTop: '1px #eef1f5 solid', paddingTop: '20px' }}>
                            <div className="btn-set pull-right" style={{ width: '150px' }}>
                                <SaveButton name="Save" loadingName="Saving"
                                            onClickEvent={this.handleClick}
                                            isLoading={this.state.isSaving}
                                            type="button" />
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        )
    }
}


/** WEBPACK FOOTER **
 ** ./src/components/management/settings/tabs/General.js
 **/